// extracted by mini-css-extract-plugin
export default {"card":"NumlA","titleCell":"PSgUW","statusCell":"W4N8q","preview":"MyQ09","title":"D9eGZ"};